import { CheckboxOption } from 'shared/common/ConvertToCheckboxOptions'

export const paymentOptions: CheckboxOption[] = [
  { label: 'Наличными', value: 'CASH' },
  { label: 'Картой в приложении', value: 'TRANSFER' },
  { label: 'Элсом', value: 'elsom' },
  { label: 'О! Банк', value: 'oBank' },
]
export const deliveryTypeOptions: CheckboxOption[] = [
  { label: 'Доставка Яндекс', value: 'YANDEX' },
]

export const orderTypeOptions: CheckboxOption[] = [
  { label: 'Доставка', value: 'COURIER' },
  { label: 'Самовывоз', value: 'PICKUP' },
]
